export default __webpack_public_path__ + "static/media/about-before-2.27f4a6af.jpg";